import * as React from 'react';

import {

  Button,

} from "antd";


import Text from "antd/lib/typography/Text";

export const EmptyState = ({onButtonClick, title, description}) => {
    return (
        <div
        style={{
          minHeight: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "32px",
          }}
        >
          <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            maxWidth:'452px',
            alignItems:'center'
          }}
        >
          <img style={{width:'200px'}} src="images/empty_state.svg" alt="Empty state" />
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                textAlign:'center'
              }}
            >
              <Text
                style={{
                  fontSize: "16px",
                  fontWeight: "600",
                  lineHeight: "20.8px",
                  color: "#343C46",
                  textAlign: "center",
                }}
              >
              {title}
              </Text>
              <Text
                style={{
                  fontSize: "14px",
                  fontWeight: "400",
                  color: "var(--gray50)",
                }}
              >
             {description}
              </Text>
            </div>
          </div>
          <div style={{ margin: "0 auto", minWidth: "100%" }}>
            <Button
              onClick={() => {
              onButtonClick()
              }}
              // label="Add New Organization"
              style={{
                borderRadius: "4px",
                background: "#07073F",
                color: "#FFFFFF",
                height: "38px",
                minWidth: "100%",
              }}
            >
              Add New Organization
            </Button>
          </div>
        </div>
      </div>
    )
}